import { METERS_PER_KM } from './lengthUnits'
import { SECONDS_PER_HOUR } from './timeUnits'

export const KMH_PER_MPS = SECONDS_PER_HOUR / METERS_PER_KM
